export default "__VITE_ASSET__3563b89f__"